var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "list-container" }, [
    _c(
      "div",
      { staticClass: "row" },
      _vm._l(
        _vm.rooms,
        function (
          { nickname, title, mico_id, cover_fid: cover, viewer_num },
          index
        ) {
          return _c(
            "div",
            { key: index, staticClass: "col-xs-6 col-sm-4 col-md-3" },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "tile-content" }, [
                  _c(
                    "a",
                    {
                      staticClass: "cover-box",
                      attrs: { href: "/live/" + mico_id },
                    },
                    [
                      _c("img", {
                        staticClass: "cover",
                        attrs: {
                          src: "//thumbnail-middle.micoworld.net/" + cover,
                          "data-cover": cover,
                          onerror:
                            "this.onerror=null;this.src='//image.micoworld.net/' + this.getAttribute('data-cover')",
                          alt: "",
                        },
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "title" }, [
                        _vm._v(_vm._s(title)),
                      ]),
                      _vm._v(" "),
                      _vm._m(0, true),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "extra" }, [
                    _c("div", { staticClass: "nickname" }, [
                      _vm._v(_vm._s(nickname)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "count" }, [
                      _c("img", {
                        attrs: {
                          src: require("@public/assets/web/viewer.png"),
                          alt: "",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(viewer_num))]),
                    ]),
                  ]),
                ]),
              ]),
            ]
          )
        }
      ),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "shadow hidden-xs" }, [
      _c("div", { staticClass: "play-icon" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }